export default __webpack_public_path__ + "static/media/health.d956ce9a.svg";